// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import L from 'leaflet'
import 'leaflet-iconmaterial/dist/leaflet.icon-material.js'
import 'leaflet-iconmaterial/dist/leaflet.icon-material.css'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'leaflet/dist/leaflet.css'
import { store } from './store/'
import { settingsResource } from '@/resources/settings_resource'
import VueResource from 'vue-resource'

const API_URL = '/'

const GOOGLE_ANALYTICS_TRACKING_ID = process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID

Vue.use(Vuetify)
Vue.use(VueResource)
Vue.use(VueAnalytics, {
  id: async () => {
    const analyticsIds = [GOOGLE_ANALYTICS_TRACKING_ID]
    const response = await settingsResource.get()
    const settings = response.body
    const clientTrackingID = settings.google_analytics_tracking_id
    if (clientTrackingID) {
      analyticsIds.push(clientTrackingID)
    }
    return analyticsIds
  },
  router,
})
Vue.http.options.root = API_URL
delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

Vue.config.productionTip = false

/* Filters */
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('distance', function(value) {
  if (value == -1) {
    return 'Unknown'
  }
  if (value < 1000) {
    const distanceMetres = Math.floor(value)
    return `${distanceMetres}m`
  }
  let distanceKilometres = Math.round(value / 1000, 1)
  if (distanceKilometres >= 1000) {
    distanceKilometres = distanceKilometres.toString()
    distanceKilometres = distanceKilometres.slice(0, 1) + ',' + distanceKilometres.slice(1)
  }
  return `${distanceKilometres}km`
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  store,
  template: '<App/>'
})
